import { useEffect, useState } from "react";
import bus from "../utils/EventBus.js";
import { useIsMounted } from "../utils/ReactUtils";
import { ApiGateway } from "../config/config";
import MaterialReactTable from "material-react-table";
import {
  Box,
  Grid,
  Paper,
  IconButton,
  InputLabel,
  MenuItem,
  Stack,
  FormControl,
  Select,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import ConfirmDialog from "../form/ConfirmDialog";
import { Link, useNavigate } from "react-router-dom";
import AddRecordDialog from "../form/AddRecordDialog";
import { useMsal } from "@azure/msal-react";
import { OIDC_DEFAULT_SCOPES } from "@azure/msal-browser";
import { useRole } from "../auth/role.js";

export default function ListAllUsersPage(props = {}) {
  const navigate = useNavigate();
  const isMounted = useIsMounted();

  const [confirmDialog, setConfirmDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("Delete this User?");
  const [fieldErrors, setFieldErrors] = useState({});
  const [userRows, setUserRows] = useState([]);
  const [userToDelete, setUserToDelete] = useState("");
  const { instance } = useMsal();
  const { ROLES, hasRole, hasAnyRole } = useRole();
  let listRoleId = 0;

  const hideAddRecord = () => {
    props.hideAddRecord();
    //setNewRecord({assessmentMonth: "", assessmentYear: "", assessor: "", status: "Open", assessmentId: "new"})
    setFieldErrors({});
  };

  const hideDialog = () => {
    setConfirmDialog(false);
  };

  const showDialog = () => {
    setConfirmDialog(true);
  };

  const userColumns = [
    {
      accessorKey: "koId",
      header: "KO ID",
      size: 10,
      editable: false,
      filterVariant: "text",
    },
    {
      accessorKey: "lastName",
      header: "Last Name",
      size: 20,
      editable: false,
      filterVariant: "text",
    },
    {
      accessorKey: "firstName",
      header: "First Name",
      size: 20,
      editable: false,
      filterVariant: "text",
    },
    {
      accessorKey: "email",
      header: "Email",
      size: 20,
      editable: false,
    },
    {
      accessorKey: "actions",
      header: "Actions",
      columnDefType: "display",
      size: 10,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0rem" }}>
          <Tooltip arrow placement="left" title="Edit">
            <Link to={"/users/edit/" + row.original.koId}>
              <IconButton>
                <EditIcon />
              </IconButton>
            </Link>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const getUserList = async () => {
    if (listRoleId > 0) {
      props.startLoading();
      const roleId = listRoleId;
      const account = instance.getActiveAccount();
      if (account && account != null) {
        const token = await instance.acquireTokenSilent({
          scopes: OIDC_DEFAULT_SCOPES,
          account,
          forceRefresh: true,
        });

        const basePath = `${ApiGateway.user}/search`;
        const options = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.idToken}`,
          },
        };
        const response = await axios.post(basePath, { roleId }, options);

        setUserRows(response.data);
      }
    }
    props.stopLoading();
    return;
  };

  const editUser = (assessmentTypePath, koId) => {
    const path = "/users/edit/" + koId;
    navigate(path);
  };

  const confirmDeleteUser = (selectedKoId) => {
    setUserToDelete(selectedKoId);
    setDialogTitle(`Delete User ${selectedKoId}?`);
    showDialog();
  };

  const deleteUser = async (selectedKoId) => {
    hideDialog();
    props.startLoading();
    bus.emit(Event.ALERT, {
      text: "Deleting Users...",
      style: "info",
      duration: 2000,
    });

    const options = {
      headers: {
        "x-api-key": ApiGateway.apiKey,
        "Content-Type": "application/json",
        Authorization: ApiGateway.auth,
      },
    };
    const path = `${ApiGateway.employee}/${selectedKoId}`;
    const response = await axios.delete(path, options);

    await getUserList();
    props.stopLoading();
    bus.emit(Event.ALERT, {
      text: "User deleted",
      style: "success",
      duration: 2000,
    });
  };

  const getDefaultView = async () => {
    let d = undefined;
    if (hasRole(ROLES.ADMIN)) d = ROLES.ADMIN;
    if (hasRole(ROLES.MFI_ADMIN)) d = ROLES.MFI_ADMIN;
    if (hasRole(ROLES.QSE_MGR)) d = ROLES.BOTTLER;

    listRoleId = d?.id || 0;
    await getUserList();
  };

  const handleViewSelectChange = async (event) => {
    listRoleId = event.target.value;
    await getUserList();
  };

  useEffect(() => {
    if (isMounted()) {
      getDefaultView();
      props.stopLoading();
    }
  }, []);

  //  <AddRecordDialog title={"Add Employee User"} content={addRecordForm} open={props.showAddRecord} hideDialog={hideAddRecord} createRecord={addAssessment} buttonLoading={buttonLoading}/>
  return (
    <>
      {/* <div className='App'> */}
      <FormControl fullWidth>
        <InputLabel>List users with Role:</InputLabel>
        <Select
          size="small"
          fullWidth
          id={`role_select`}
          defaultValue={listRoleId}
          onChange={handleViewSelectChange}
        >
          <MenuItem value={0}>Select A Role</MenuItem>
          {hasRole([ROLES.ADMIN]) && (
            <MenuItem value={ROLES.ADMIN.id}>{ROLES.ADMIN.name}</MenuItem>
          )}
          {hasRole([ROLES.ADMIN, ROLES.MFI_ADMIN]) && (
            <MenuItem value={ROLES.MFI_ADMIN.id}>
              {ROLES.MFI_ADMIN.name}
            </MenuItem>
          )}
          {hasRole([ROLES.ADMIN, ROLES.MFI_ADMIN]) && (
            <MenuItem value={ROLES.QSE_MGR.id}>{ROLES.QSE_MGR.name}</MenuItem>
          )}
          {hasAnyRole() && !hasRole([ROLES.BOTTLER]) && (
            <MenuItem value={ROLES.BOTTLER.id}>{ROLES.BOTTLER.name}</MenuItem>
          )}
        </Select>
      </FormControl>

      <ConfirmDialog
        title={dialogTitle}
        text="The record will be permanently deleted"
        open={confirmDialog}
        hideDialog={hideDialog}
        handleConfirm={() => deleteUser(userToDelete)}
        yesLabel="Delete"
        noLabel="Keep"
      />
      <Paper
        sx={{
          backgroundColor: "transparent",
          p: "0 0 3em 0",
          border: "none",
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          width: "96%",
          margin: "1em auto",
        }}
      >
        <Grid container rowSpacing={2}>
          <Grid item xs={true} md={true}>
            <MaterialReactTable
              columns={userColumns}
              data={userRows}
              enableColumnActions={false}
              enableColumnFilters={props.showFilters}
              initialState={{ showColumnFilters: true }}
              enablePagination={true}
              enableSorting={true}
              enableBottomToolbar={true}
              enableEditing={false}
              muiTableContainerProps={{ sx: { minHeight: 300 } }}
              renderTopToolbar={false}
            />
          </Grid>
        </Grid>
      </Paper>
      {/* </div> */}
    </>
  );
}
